module.exports = __webpack_public_path__ + "static/media/header-bg-1-rough.71eddfea.png";